module.exports = __webpack_public_path__ + "img/HomeFurnishingBanner.95aa474e.png";